"use client";

import React, { forwardRef } from "react";
import { TypeProgram_metaWithoutUnresolvableLinksResponse } from "@2u-landing-pages/types";
import { ProductCardProps } from "./ProductCard.type";
import { Default } from "./variations/Default";
import { Extended } from "./variations/Extended";
import { PricingApiContextProvider, ProgramMetaProvider } from "@2u-landing-pages/providers";

export const ProductCard = forwardRef<HTMLDivElement, ProductCardProps>((props, ref) => {
  const cardSize = props.galleryCardSize || props.product?.fields?.product_card_size;
  const isExtended = cardSize?.toLowerCase().includes("extended");

  return (
    <ProgramMetaProvider programMeta={props?.product?.fields?.program_meta as TypeProgram_metaWithoutUnresolvableLinksResponse}>
      <PricingApiContextProvider programMeta={props?.product?.fields?.program_meta as TypeProgram_metaWithoutUnresolvableLinksResponse}>
        {isExtended ? <Extended {...props} ref={ref} /> : <Default {...props} ref={ref} />}
      </PricingApiContextProvider>
    </ProgramMetaProvider>
  );
});

ProductCard.displayName = "ProductCard";
